import { listOrders } from 'graphql/orders';
import { DynamicTool } from '@langchain/core/tools';
import graphql from 'services/querys';
import { getNarrative } from 'graphql/narrative/queries';

const toolOrderSearch = new DynamicTool({
  name: 'orderSearch',
  description:
    'Returns a list of possible orders in JSON format.\n\nMust be used to get the full order identifier when incomplete by picking up data from the first item.',
  func: async (query) => {
    let response;
    try {
      response = await listOrders({ searchText: query, pagination: { items: 5, page: 1 } });
    } catch (error: any) {
      response = { error: error.message };
    }
    return JSON.stringify(response, null, 2);
  },
});

const toolOrderInfo = new DynamicTool({
  name: 'orderInfo',
  description:
    'Returns all information about an order in narrative format.\n\nRequires a full order identifier in the format YYYY/MM/DD/00000 and the date cannot be guessed.',
  func: async (id) => {
    let response;
    try {
      response = await getNarrative({ orderId: id });
    } catch (error: any) {
      response = error.message;
    }
    return response.getOrder.narrative;
  },
});

const toolPartySearch = new DynamicTool({
  name: 'partySearch',
  description:
    // eslint-disable-next-line max-len
    'Returns a list of information about possible persons or companies in JSON format.\n\nIt returns the most approximate names and there is no way to tell if an exact match was found, a list with the matched information must be presented when in doubt.',
  func: async (query) => {
    let response;
    try {
      response = await graphql.searchParty(query);
    } catch (error: any) {
      response = { error: error.message };
    }
    return JSON.stringify(response, null, 2);
  },
});

export const toolList = [toolOrderSearch, toolOrderInfo, toolPartySearch];
